import { Typography } from "@mui/material";

export default function ChronoTitle({ children }) {
    return (
        <Typography
            variant="h4"
            sx={{
                fontWeight: 700,
                mb: 3,
                color: "primary.main",
            }}
        >
            {children}
        </Typography>
    );
}
